import { useContext, useEffect, useState } from "react"
import { AppContext } from "./context"
import UiInput1 from "./ui_input1"
import UiButton1 from "./ui_button1"
import UiSpinner from "./ui_spinner"

const UserEdit = () => {

    const {
        neonUser,
        selectedUser, setSelectedUser,
        setReloadList,
        setToastContent,
        toastInit,
        fetchDataV2,
        offCanvas
    } = useContext(AppContext)

    const [search, setSearch] = useState("")
    const [entityList, setEntityList] = useState([])
    const [selectedEntities, setSelectedEntities] = useState([])
    const [load, setLoad] = useState(false)
    const [error, setError] = useState("")
    const [message, setMessage] = useState("")
    const [roles] = useState(["admin", "normal", "editor"])

    const selectedUserChangeHandler = (field, value) => {
        if (field == 'role' && ["admin", "owner"].includes(value)) {
            setSelectedUser({ ...selectedUser, all_entities: true, [field]: value })
            return
        }
        setSelectedUser({ ...selectedUser, [field]: value })
    }

    const addRemoveEntity = (x) => {
        if (selectedEntities.map(xx => xx.id).includes(x.id)) {
            setSelectedEntities([...selectedEntities.filter(xx => xx.id != x.id)])
            return
        }
        else {
            setSelectedEntities([...selectedEntities, x])
            return
        }
    }

    const getEntityList = async () => {
        let query1 = "GET_BRANDS_1", params1 = [neonUser.agency_id]
        let resp = await fetchDataV2(query1, params1, "/neon-query-v2")
        setEntityList(resp)
    }

    const updateSelectedUser = async () => {
        setLoad(true)
        setError("")
        setMessage("")

        let editedUser = {
            ...selectedUser,
            entity_id_list: selectedEntities.map(x => x.id)
        }

        if (editedUser.entity_id_list.length == 0 && !editedUser.all_entities) {
            setError("Must select atleast 1 brand/account")
            setLoad(false)
            return
        }

        let query1 = "UPDATE_AUTH0_USER", params1 = [
            editedUser.entity_id_list,
            editedUser["active?"],
            editedUser.all_entities,
            editedUser.role,
            editedUser.id
        ]

        try {
            await fetchDataV2(query1, params1, "/neon-query-v2")
            setMessage("User successfully updated.")
            setToastContent("User successfully updated.")
            toastInit.show()
            offCanvas.hide()
            setReloadList(true)
            setLoad(false)
            return
        }
        catch (err) {
            setError("Something went wrong: " + err)
            setLoad(false)
            return
        }
    }

    useEffect(() => {
        if (neonUser.user_id) getEntityList()
    }, [neonUser])

    useEffect(() => {
        if (selectedUser.id && entityList.length > 0) {
            setSelectedEntities((() => {
                let list = entityList.filter(x => selectedUser.entity_id_list.includes(x.id))
                return list
            })())
        }
    }, [selectedUser, entityList])

    return (
        <div className="d-flex flex-column justify-content-between h-100">
            <div className="d-flex flex-column gap-3">
                {error && <p className="poppins text-danger">{error}</p>}
                {message && <p className="poppins text-success">{message}</p>}

                <div>
                    <p className="poppins fw-bold mb-1">Email Address</p>
                    <UiInput1 field="email" value={selectedUser.email || ""} readOnly={true} userChangeHandler={null} />
                </div>

                <div>
                    <p className="poppins fw-bold mb-1">Role</p>
                    <div className="d-flex gap-1 dropdown">
                        <div data-bs-toggle="dropdown" aria-expanded="false">
                            <UiInput1 capitalize={true} field="" value={selectedUser.role == 'normal' ? "read only" : selectedUser.role} userChangeHandler={null} readOnly={true} dropdown={true} />
                        </div>
                        <div className="dropdown-menu">
                            {roles.map(x => (
                                <p key={x} onClick={() => selectedUserChangeHandler('role', x)} className="poppins dropdown-item mb-1 text-capitalize">
                                    {x == 'normal' ? "Read Only" : x}
                                </p>
                            ))}
                        </div>
                    </div>
                </div>

                {["normal", "editor"].includes(selectedUser.role) && (
                    <div className="d-flex flex-column gap-1">
                        <p className="mb-0 fw-bold poppins">Brand/Account Access</p>
                        <div className="d-flex gap-3">
                            <input type="radio" name="selected" className="input-radio align-self-center" onChange={(e) => selectedUserChangeHandler('all_entities', true)} checked={selectedUser.all_entities} />
                            <span className="poppins align-self-center">All</span>
                            <input type="radio" name="selected" className="input-radio align-self-center" onChange={(e) => selectedUserChangeHandler('all_entities', false)} checked={!selectedUser.all_entities} />
                            <span className="poppins align-self-center">Selected</span>
                        </div>
                    </div>
                )}

                {!selectedUser.all_entities && ["editor", "normal"].includes(selectedUser.role) && (
                    <div>
                        <p className="poppins fw-bold mb-1">Brands/Accounts</p>
                        <div className="d-flex gap-1 dropdown-center">
                            <div className="w-75" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside">
                                <UiInput1 dropdown={true} readOnly={true} value={(selectedEntities.length || 'No') + (selectedEntities.length > 1 ? " Brands/Accounts" : " Brand/Account")} userChangeHandler={null} />
                            </div>
                            <ul className="dropdown-menu">
                                <div className="px-2">
                                    <input type="text" value={search} onChange={(e) => setSearch(e.target.value)} className="form-control form-control-sm mb-1 poppins" placeholder="search..." />
                                </div>
                                <li className="px-2 d-flex flex-column gap-1" style={{ maxHeight: 200, overflowY: 'auto' }}>
                                    {entityList.filter(x => x.brand.toLowerCase().includes(search.toLowerCase())).map(x => (
                                        <div key={x.id} style={{ maxWidth: 200, cursor: "pointer" }} className="d-flex gap-2" onClick={() => addRemoveEntity(x)}>
                                            {selectedEntities.map(xx => xx.id).includes(x.id) ?
                                                <i className="bi bi-check-square"></i>
                                                :
                                                <i className="bi bi-square"></i>
                                            }
                                            <p className="poppins text-truncate mb-0" title={x.brand}>{x.brand}</p>
                                        </div>
                                    ))}
                                </li>
                            </ul>
                        </div>
                    </div>
                )}

                <div className="d-flex flex-column gap-2">
                    <p className="mb-0 fw-bold poppins">User Status</p>
                    <div className="d-flex gap-3">
                        <input type="radio" name="status" className="input-radio align-self-center" checked={selectedUser['active?'] || false} onChange={e => selectedUserChangeHandler("active?", true)} />
                        <span className="poppins align-self-center">Active</span>
                        <input type="radio" name="status" className="input-radio align-self-center" checked={!selectedUser['active?'] || false} onChange={e => selectedUserChangeHandler("active?", false)} />
                        <span className="poppins align-self-center">Inactive</span>
                    </div>
                </div>
            </div>

            {load ?
                <UiSpinner />
                :
                <UiButton1 text="Update User" submit={updateSelectedUser} />
            }
        </div>
    )
}

export default UserEdit